var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarTodaySm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    width: 18,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#f96c6c}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m2.3 19.5c-0.5 0-0.9-0.2-1.3-0.5-0.4-0.3-0.5-0.8-0.5-1.3v-13.4c0-0.5 0.2-0.9 0.5-1.3 0.3-0.3 0.8-0.5 1.3-0.5h1.4v-1.4c0-0.2 0.1-0.4 0.2-0.5 0.1-0.1 0.3-0.2 0.5-0.2 0.2 0 0.4 0.1 0.5 0.2 0.1 0.1 0.2 0.3 0.2 0.5v1.3h7.6v-1.3c0-0.2 0.1-0.4 0.2-0.5 0.1-0.1 0.3-0.2 0.5-0.2 0.2 0 0.4 0.1 0.5 0.2 0.1 0.1 0.2 0.3 0.2 0.5v1.4h1.4c0.5 0 0.9 0.2 1.3 0.5 0.4 0.4 0.5 0.8 0.5 1.3v13.4c0 0.5-0.2 0.9-0.5 1.3-0.3 0.4-0.8 0.5-1.3 0.5zm0-1.5h13.4c0.1 0 0.1 0 0.2-0.1 0.1-0.1 0.1-0.1 0.1-0.2v-9.4h-14v9.4c0 0.1 0 0.1 0.1 0.2 0.1 0.1 0.1 0.1 0.2 0.1zm-0.3-11.2h14v-2.5c0-0.1 0-0.1-0.1-0.2-0.1-0.1-0.1-0.1-0.2-0.1h-13.4c-0.1 0-0.1 0-0.2 0.1-0.1 0.1-0.1 0.1-0.1 0.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTodaySm);
export default __webpack_public_path__ + "static/media/calendar_today-sm.02fb9a74f1e2c58dbe91ca2438028a4a.svg";
export { ForwardRef as ReactComponent };